import { render, staticRenderFns } from "./studentImport.vue?vue&type=template&id=457f0f62&scoped=true&"
import script from "./studentImport.vue?vue&type=script&lang=ts&"
export * from "./studentImport.vue?vue&type=script&lang=ts&"
import style0 from "./studentImport.vue?vue&type=style&index=0&id=457f0f62&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "457f0f62",
  null
  
)

export default component.exports